export default __webpack_public_path__ + "static/media/get-quote.d8e6f1c8.svg";